import React, { useState } from "react";
import FilterForm from "../FilterForm/FilterForm";
import firebase from "firebase/app";
import "./FilterColumn.css";
import { runAnalytics } from "../../utils";

const FilterColumn = ({ submitQueries }) => {
  const [queries, setQueries] = useState([[]]);

  const updateQueries = (indexOfQuery, column, newValue) => {
    let newQueries = queries;
    newQueries[indexOfQuery][column] = newValue;
    setQueries(newQueries);
  };

  const handleSubmit = event => {
    event.preventDefault();
    submitQueries(queries);

    if (runAnalytics({ userEmail: firebase.auth().currentUser.email, window }))
      window.analytics.track("Filtered Sites", {
        queries: JSON.stringify(queries)
      });
  };

  const clear = event => {
    event.preventDefault();
    setQueries([["url", "==", ""]]);
    submitQueries([[]]);
  };

  const addFilter = () => {
    setQueries([queries[0], []]);

    if (runAnalytics({ userEmail: firebase.auth().currentUser.email, window }))
      window.analytics.track("Added Compound Filter");
  };

  return (
    <div className="filters__container">
      <div className="forms__label">Table Filters</div>
      <div>
        <form onSubmit={handleSubmit}>
          <FilterFormList updateQueries={updateQueries} queries={queries} />

          {queries.length < 2 && (
            <div className="filters__add-filter-button" onClick={addFilter}>
              +
            </div>
          )}

          <div className="filters__buttons">
            <input
              className="app__primary-button filter__button"
              type="submit"
              value="Filter"
            />
            <input
              className="app__primary-button"
              type="button"
              onClick={clear}
              value="Clear"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

const FilterFormList = ({ queries, updateQueries }) => {
  return queries.map((query, indexQuery) => {
    return (
      <FilterForm
        key={indexQuery}
        query={query}
        indexQuery={indexQuery}
        updateQueries={updateQueries}
      />
    );
  });
};

export default FilterColumn;
